import { useSession } from '@ory/elements-react/client';
import { useRouter } from 'next/navigation';
import { useCallback, useEffect } from 'react';

import { useAuth, useAuthActorRef, useAuthSelector } from '@/contexts';
import { getOry, logout } from '@/utils';

export function useLogout(onLoggedOut?: () => void) {
  const router = useRouter();
  const { refetch: refetchSession } = useSession();
  const { send } = useAuthActorRef();
  const currentState = useAuthSelector((state) => state);
  const { resetState } = useAuth();
  const ory = getOry();

  const onLoggedOutDefault = useCallback(() => {
    router.push('/login');
  }, [router]);

  const initiateLogout = async () => {
    send({ type: 'LOG_OUT' });
    await logout(ory);
    router.push('/login');
  };

  useEffect(() => {
    if (currentState.matches('loggedOut')) {
      refetchSession();
      resetState();
      (onLoggedOut ?? onLoggedOutDefault)();
    }
  }, [
    currentState,
    refetchSession,
    resetState,
    onLoggedOut,
    onLoggedOutDefault,
  ]);

  return { initiateLogout };
}
